// extracted by mini-css-extract-plugin
export default {"loginBackground":"Login_loginBackground__0Y0pH","loginContainer":"Login_loginContainer__GxM8Q"};